import { render, staticRenderFns } from "./integral-detail.vue?vue&type=template&id=fc068cf0&scoped=true&"
import script from "./integral-detail.vue?vue&type=script&lang=js&"
export * from "./integral-detail.vue?vue&type=script&lang=js&"
import style0 from "./integral-detail.vue?vue&type=style&index=0&id=fc068cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc068cf0",
  null
  
)

export default component.exports